<template>
  <div>
    <v-card
      :style="[
        $vuetify.breakpoint.height < 786
          ? { 'min-height': '100vh', 'background-color': BackgroundColor }
          : $vuetify.breakpoint.height >= 947
          ? { 'min-height': '91vh', 'background-color': BackgroundColor }
          : { height: 'auto', 'background-color': BackgroundColor },
      ]"
    >
      <div style="margin-left: 10px; margin-right: 10px">
        <div
          style="
            font-size: 18px;
            margin-left: 1rem;
            margin-right: 1rem;
            color: #444444;
            cursor: default;
            margin-top: -1rem;
          "
        ></div>
        <v-card-text>
          <div>
            <v-row cols="12" xs="12" sm="12" md="12" justify="center">
              <v-col cols="12" md="8" align="center">
                <v-text-field
                  class="centered-input-header"
                  :value="
                    SiteName == '' || MainPageActiveStatus == false
                      ? ''
                      : SiteName
                  "
                  disabled
                  solo
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row cols="12" xs="12" sm="12" md="12" justify="center">
              <v-col cols="12" md="4" align="center">
                <p
                  style="
                    text-align: center;
                    font-size: 22px;
                    color: #14223c;
                    cursor: pointer;
                  "
                  @click="OpenCheckPermissionDialog()"
                >
                  {{ $t("message.Redemption") }}
                </p>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                <v-tabs>
                  <v-tab @click="ChangeTab('Search')"
                    ><span :style="[{ color: ColorText }]">{{
                      $t("message.Search")
                    }}</span></v-tab
                  >
                  <v-tab @click="ChangeTab('QR')"
                    ><span :style="[{ color: ColorText2 }]">{{
                      $t("message.ScanQRCode")
                    }}</span></v-tab
                  >
                  <v-tabs-slider :color="ColorTab"></v-tabs-slider>

                  <v-tab-item>
                    <v-card flat>
                      <v-card-text>
                        <v-row
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          justify="center"
                          :style="[
                            $vuetify.breakpoint.height >= 947
                              ? { 'margin-top': '5rem' }
                              : $vuetify.breakpoint.height == 929
                              ? { 'margin-top': '5rem' }
                              : false,
                          ]"
                        >
                          <v-col cols="12" md="6">
                            <p class="TitleCSS">
                              {{ $t("message.PleaseInput") }}
                            </p>
                            <v-text-field
                              :placeholder="$t('message.InputPlaceholder')"
                              solo
                              v-model="SearchInput"
                              @keyup.enter="NextToSelectVehicleType"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          justify="center"
                        >
                          <v-col cols="12" md="4" align="center">
                            <v-btn
                              height="40"
                              width="150"
                              outlined
                              color="indigo"
                              @click="NextToSelectVehicleType()"
                            >
                              {{ $t("message.Next") }}
                            </v-btn>
                            &nbsp;
                            <v-btn
                              height="40"
                              width="150"
                              outlined
                              color="red"
                              @click="CloseTab()"
                            >
                              {{ $t("message.Close") }}
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item>
                    <v-card flat>
                      <v-card-text>
                        <v-row cols="12">
                          <v-col cols="12" md="4"></v-col>
                          <v-col cols="12" md="4" align="center">
                            <div v-if="Status">
                              <StreamBarcodeReader
                                ref="scanner"
                                style="height: auto"
                                @decode="onDecode"
                              ></StreamBarcodeReader>
                            </div>
                          </v-col>
                          <v-col cols="12" md="4"></v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                </v-tabs>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
      </div>
    </v-card>

    <v-dialog v-model="LoadingDialog" persistent width="0.01">
      <v-card>
        <v-card-text>
          <v-row>
            <LoadingComponent class="centered"></LoadingComponent>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="CheckPermissionDialog" persistent width="300">
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn
            style="margin-top: -10px; z-index: 1"
            @click="CloseCheckPermissionDialog()"
            icon
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row style="margin-bottom: -50px">
            <v-col cols="12" md="1"></v-col>
            <v-col cols="12" md="10">
              <v-text-field
                placeholder="Username"
                type="text"
                outlined
                v-model="UserAdmin"
                @keyup.enter="LoginPermission"
              />
              <v-text-field
                placeholder="Password"
                type="password"
                outlined
                v-model="PasswordAdmin"
                @keyup.enter="LoginPermission"
              />
            </v-col>
            <v-col cols="12" md="1"></v-col>
          </v-row>
          <v-row style="margin-bottom: -40px">
            <v-col cols="12" md="1"></v-col>
            <v-col cols="12" md="10">
              <v-btn
                block
                color="#1D2939"
                style="color: white"
                @click="LoginPermission()"
                class="rounded-lg"
                x-large
                >Login</v-btn
              >
            </v-col>
            <v-col cols="12" md="1"></v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="SettingMainDialog" persistent width="800">
      <v-card>
        <v-card-title>
          <p>Setting</p>
          <v-spacer></v-spacer>
          <v-btn
            style="margin-top: -10px; z-index: 1"
            @click="CloseSettingMainDialog()"
            icon
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row class="ml-5 mr-2">
            <v-col col="12" md="6">
              <p style="font-size: 13px; color: black">Site Name</p>
              <v-text-field v-model="SiteName" solo></v-text-field>
            </v-col>
            <v-col col="12" md="6"></v-col>
          </v-row>
          <v-row class="ml-5 mr-2">
            <v-col col="12" md="6">
              <p style="font-size: 13px; color: black">SiteName Color</p>
              <div>
                <v-color-picker
                  v-model="SiteNameColor"
                  dot-size="20"
                  class="ma-2"
                  mode="hexa"
                ></v-color-picker>
              </div>
            </v-col>
            <v-col col="12" md="6">
              <p style="font-size: 13px; color: black">BackgroundColor Color</p>
              <div>
                <v-color-picker
                  v-model="BackgroundColor"
                  dot-size="20"
                  class="ma-2"
                  mode="hexa"
                ></v-color-picker>
              </div>
            </v-col>
          </v-row>
          <v-row class="ml-5 mr-2">
            <p style="text-align: left; font-size: 16px; color: black">
              Status
            </p>
            <v-radio-group inline v-model="MainPageActiveStatus">
              <v-radio label="Active" value="1"></v-radio>
              <v-radio label="InActive" value="2"></v-radio>
            </v-radio-group>
          </v-row>
          <hr class="mt-2" />
          <v-row>
            <v-col cols="12" md="1"></v-col>
            <v-col cols="12" md="1"></v-col>
            <v-col cols="12" md="10" align="right">
              <v-btn
                height="40"
                width="150"
                color="success"
                outlined
                @click="SaveSettingMain()"
              >
                {{ $t("message.Submit") }}
              </v-btn>
              <v-btn
                height="40"
                width="150"
                color="red"
                outlined
                @click="CloseSettingMainDialog()"
              >
                {{ $t("message.Cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-footer
      :color="
        ThemeColor == '' || ActiveStatus == false ? '#1d2939' : ThemeColor
      "
      :absolute="$vuetify.breakpoint.height < 786 ? false : true"
      class="white--text text-caption footer"
    >
      <v-row no-gutters>
        <v-col cols="12" xs="12" sm="12" md="12">
          <v-row no-gutters>
            <v-col cols="12" xs="12" sm="4" md="4" lg="2"></v-col>
            <v-col cols="12" xs="12" sm="4" md="4" lg="1">
              <v-img
                src="@/assets/logo_fs.svg"
                width="80"
                class="mx-auto mt-1"
              ></v-img>
            </v-col>
            <v-col cols="12" xs="12" sm="4" md="4" lg="3">
              <div class="mt-2">
                <span style="font-size: small; margin-bottom: 5px; color: white"
                  >Copyright © 2023 Forward System Co. Ltd. All rights reserved.</span
                >
              </div>
            </v-col>
            <v-col cols="12" xs="12" sm="4" md="4" lg="6"></v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-footer>

    <AlertComponent
      :flagAlert="AlertDialog"
      :typeAlert="TypeAlert"
      :mesAlert="MessageAlert"
      @flagClose="ClearDataAlert()"
    />
  </div>
</template>
<script>
import axios from "axios";
import { StreamBarcodeReader } from "vue-barcode-reader";
import enurl from "@/api/environment";
import AlertComponent from "@/components/Alert";
import LoadingComponent from "@/components/Loading";
export default {
  name: "SelectVehicleType",
  components: {
    AlertComponent,
    StreamBarcodeReader,
    LoadingComponent,
  },
  data() {
    return {
      url: enurl.apiUrl,
      LoadingDialog: false,
      AlertDialog: false,
      TypeAlert: null,
      MessageAlert: "",
      model: "tab-1",
      SearchInput: "",
      QRCodeData: "",
      id: null,
      destroy: false,
      Status: false,
      response: "",
      ColorTab: "#126496",
      ColorText: "#126496",
      ColorText2: "",

      CheckPermissionDialog: false,
      UserAdmin: "",
      PasswordAdmin: "",
      SettingMainDialog: false,
      ThemeColor: "",
      ActiveStatus: false,
      SiteName: "",
      // HeaderName: "",
      SiteNameColor: "",
      BackgroundColor: "",
      MainPageActiveStatus: false,
    };
  },
  computed: {},
  watch: {},

  methods: {
    onDecode(temp) {
      this.QRCodeData = temp;
      if (this.id) clearTimeout(this.id);
      this.id = setTimeout(() => {
        if (this.QRCodeData === temp) {
          this.QRCodeData = "";
        }
      }, 5000);
      this.SearchQRCodeToSelectVehicleType();
    },

    ChangeTab(value) {
      let self = this;
      if (value == "Search") {
        self.$refs.scanner.codeReader.stream
          .getTracks()
          .forEach(function (track) {
            track.stop();
          });
        self.ColorTab = "#126496";
        self.ColorText = "#126496";
        self.ColorText2 = "#8B8B8B";
        self.Status = false;
      } else {
        self.ColorTab = "orange";
        self.ColorText2 = "orange";
        self.Status = true;
        self.$refs.scanner.codeReader.stream
          .getTracks()
          .forEach(function (track) {
            track.stream();
          });
      }
    },

    CloseTab() {
      window.close();
    },

    ClearDataAlert() {
      let self = this;
      self.AlertDialog = false;
      self.TypeAlert = "";
      self.MessageAlert = "";
    },

    SearchQRCodeToSelectVehicleType() {
      let self = this;
      if (self.QRCodeData != "") {
        // let DataArray = self.QRCodeData.split("/");
        // let inputdata = DataArray[DataArray.length - 1];
        self.SearchParkingByQRCode(self.QRCodeData);
        // self.$router.push({
        //   name: "SelectVehicleType",
        //   params: { input: inputdata },
        // });
        // self.$refs.scanner.codeReader.stream
        //   .getTracks()
        //   .forEach(function (track) {
        //     track.stop();
        //   });
      }
    },
    //GetParkingDetailByQRCode
    SearchParkingByQRCode(data) {
      let self = this;
      // self.LoadingDialog = true;
      let temp = {
        LogCarparkID: data,
        LostCard: false,
      };
      axios
        .post(`${self.url}Redemption/GetParkingDetailByQRCode`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.response = response.data.data;
            // self.LoadingDialog = false;
            self.$refs.scanner.codeReader.stream
              .getTracks()
              .forEach(function (track) {
                track.stop();
              });
            self.$router.push({
              name: "ParkingInformation",
              params: { response: self.response, LogID: self.LogCarparkID },
            });
          } else {
            // self.LoadingDialog = false;
            alert(response.data.message);
            // self.MessageAlert = response.data.message;
            // self.TypeAlert = "error";
            // self.AlertDialog = true;
          }
        })
        .catch(function (error) {
          // self.LoadingDialog = false;
          alert(error);
        });
    },

    SearchParking() {
      let self = this;
      // self.LoadingDialog = true;
      let temp = {
        search: self.SearchInput,
        LostCard: false,
      };
      axios
        .post(`${self.url}Redemption/GetParkingDetail`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.response = response.data.data;
            // self.LoadingDialog = false;
            self.$router.push({
              name: "ParkingInformation",
              params: { response: self.response, LogID: self.LogCarparkID },
            });
          } else {
            // self.LoadingDialog = false;
            alert(response.data.message);
          }
        })
        .catch(function (error) {
          // self.LoadingDialog = false;
          alert(error);
        });
    },

    NextToSelectVehicleType() {
      let self = this;
      self.SearchParking();
      // self.$router.push({
      //   name: "SelectVehicleType",
      //   params: { input: self.SearchInput },
      // });
    },

    OpenCheckPermissionDialog() {
      let self = this;
      self.CheckPermissionDialog = true;
    },

    LoginPermission() {
      let self = this;
      if (
        self.UserAdmin.toLocaleLowerCase() == "admin" &&
        self.PasswordAdmin.toLocaleLowerCase() == "fscp_1"
      ) {
        self.OpenSettingLoginPage();
      } else {
        self.MessageAlert = "รหัสผ่านไม่ถูกต้อง !";
        self.TypeAlert = "error";
        self.AlertDialog = true;
        // alert("รหัสผ่านไม่ถูกต้อง !");
      }
    },

    CloseCheckPermissionDialog() {
      let self = this;
      self.UserAdmin = "";
      self.PasswordAdmin = "";
      self.CheckPermissionDialog = false;
    },

    OpenSettingLoginPage() {
      let self = this;
      // self.CloseCheckPermissionDialog();
      self.SettingMainDialog = true;
    },

    async LoadDataSettingLogin() {
      let self = this;
      await axios
        .get(`${self.url}Setting/LoadDataSettingLogin`)
        .then(function (response) {
          if (response.data.status == 0) {
            if (response.data.data.activeStatus == true) {
              self.ActiveStatus = response.data.data.activeStatus;
              self.ThemeColor = response.data.data.themeColor;
            }
          }
        })
        .catch(function (error) {
          alert(error);
        });
    },

    CloseSettingMainDialog() {
      let self = this;
      self.CheckPermissionDialog = false;
      self.SettingMainDialog = false;
    },

    SaveSettingMain() {
      let self = this;
      let temp = {
        SiteName: self.SiteName,
        // HeaderName: self.HeaderName,
        SiteNameColor: self.SiteNameColor,
        BackgroundColor: self.BackgroundColor,
        MainPageActiveStatus: self.MainPageActiveStatus,
      };
      axios
        .post(`${self.url}Setting/AddDataSettingMainPage`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            // alert(response.data.message);
            self.SettingMainDialog = false;
            self.CheckPermissionDialog = false;
            self.UserAdmin = "";
            self.PasswordAdmin = "";
            self.LoadDataSettingMainPage();
          }
        })
        .catch(function (error) {
          alert(error);
        });
    },

    async LoadDataSettingMainPage() {
      let self = this;
      await axios
        .get(`${self.url}Setting/LoadDataSettingMainPage`)
        .then(function (response) {
          if (response.data.status == 0) {
            if (response.data.data.activeStatus == true) {
              self.SiteName = response.data.data.siteName;
              // self.HeaderName = response.data.data.headerName;
              self.SiteNameColor = response.data.data.siteNameColor;
              self.BackgroundColor = response.data.data.backgroundColor;
              self.MainPageActiveStatus =
                response.data.data.activeStatus == true ? "1" : "2";
            }
          }
        })
        .catch(function (error) {
          alert(error);
        });
    },

    CheckToken() {
      var Token = localStorage.getItem("Token");
      if (!Token || this.isTokenExpired(Token)) {
        alert("Session หมดอายุ กรุณาเข้าสู่ระบบใหม่");
        localStorage.clear();
        this.$router.push("/Login");
      }
    },

    isTokenExpired(token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        const now = Math.floor(Date.now() / 1000);
        return payload.exp < now;
      } catch (e) {
        return true;
      }
    }
  },

  async mounted() {
    this.LoadDataSettingLogin();
    this.LoadDataSettingMainPage();
    this.CheckToken();
    this.tokenCheckInterval = setInterval(() => {
      this.CheckToken();
    },1000);
  },

  beforeDestroy() {
    clearInterval(this.tokenCheckInterval);
  }
};
</script>
<style scoped>
.scan-confirmation {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);

  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
}
.centered-input-header >>> input {
  text-align: center;
  color: black;
}
.TitleCSS {
  font-size: 18px;
  font-weight: 300;
  color: black;
}
@font-face {
  font-family: "English";
  src: local("English"), url(../assets/Font/Kanit-Regular.ttf);
}
* >>> .v-data-table-header {
  background-color: #333333 !important;
  color: #ffffff !important;
}
* >>> .v-data-table-header th {
  font-size: 14px !important;
  color: #ffffff !important;
}
.addUserTitle {
  font-size: 14px;
  font-weight: 300;
}
.input-border {
  border: 1px solid black;
  height: 35px;
  padding: 4px;
}
.validation-class {
  color: red;
  font-size: 12px;
}
.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  color: white;
  text-align: center;
}
.centered {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
